import { MassTortSurveysView } from "@/components/features/mass-torts/MassTortSurveysView";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/mass-torts/$massTortSearchId/_layout/surveys",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { massTortSearchId } = Route.useParams();
  return <MassTortSurveysView massTortId={massTortSearchId} />;
}
